<template>
  <div>
    <!-- <h2>Page Not Found</h2> -->
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
};
</script>

<style scoped lang="scss">
div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
